import {computed, ref} from 'vue';

/* REGISTER */
const action = ref({});
const isLogin = computed(() => action.value === 'LOGIN');
const isRegister = computed(() => action.value === 'REGISTER');

function setAction(data) {
  action.value = data;
}

export function useAppAction() {
  return {
    setAction,
    isLogin,
    isRegister,
  };
}
